'use strict';
define(['angular'], function (angular) {

    function ExamsNavigatorController($scope, $element, $timeout, $window, $filter) {
        var ctrl = this;
        var doc = $window.document;
        var scrollContainer = null;
        var listenersBound = false;
        var rafId = null;
        var activeLockId = null;
        var activeLockTimer = null;

        ctrl.items = [];
        ctrl.activeId = null;
        ctrl.navTitle = 'seochecker.exams';

        ctrl.$onInit = function () {
            rebuild();
            bindScrollListeners();
            // Give the exams and their layout enough time to settle before the
            // first measurement. Later measurements are driven by the scroll
            // listener, so expanded content does not need a cached offset.
            $timeout(updateActiveSection, 0, false);
            $timeout(updateActiveSection, 250, false);
        };

        ctrl.$onChanges = function (changes) {
            if (changes.exams || changes.categories || changes.navigationIndex || changes.title) {
                rebuild();
                $timeout(updateActiveSection, 0, false);
            }
        };

        ctrl.$onDestroy = function () {
            unbindScrollListeners();

            if (rafId) {
                cancelFrame(rafId);
                rafId = null;
            }

            if (activeLockTimer) {
                $timeout.cancel(activeLockTimer);
                activeLockTimer = null;
            }
        };

        ctrl.goTo = function (item, event) {
            if (!item) {
                return;
            }

            if (event) {
                event.preventDefault();
            }

            var target = doc.getElementById(item.id);
            if (!target) {
                return;
            }

            var container = scrollContainer || findScrollContainer();
            var top = getScrollTopFor(target, container);

            setActive(item.id, true);
            lockActiveSection(item.id);
            smoothScrollTo(container, Math.max(0, top));
        };

        ctrl.onItemKeydown = function (event, index) {
            var nextIndex = index;

            if (event.key === 'ArrowDown') {
                nextIndex = index + 1;
            } else if (event.key === 'ArrowUp') {
                nextIndex = index - 1;
            } else if (event.key === 'Home') {
                nextIndex = 0;
            } else if (event.key === 'End') {
                nextIndex = ctrl.items.length - 1;
            } else {
                return;
            }

            if (nextIndex < 0 || nextIndex >= ctrl.items.length) {
                return;
            }

            event.preventDefault();
            ctrl.goTo(ctrl.items[nextIndex]);
            focusItem(ctrl.items[nextIndex].id);
        };

        function rebuild() {
            var previousActiveId = ctrl.activeId;
            var items = [];

            if (ctrl.exams) {
                angular.forEach(ctrl.exams, function (exam) {
                    if (exam && exam.id) {
                        items.push(createItem(exam.id, exam.title, exam.order, exam.score));
                    }
                });
                ctrl.navTitle = ctrl.title || 'seochecker.exams';
            } else if (ctrl.categories) {
                angular.forEach(ctrl.categories, function (categoryExams, categoryName) {
                    items.push(createItem(categoryName.split(' ').join('_'), categoryName, 0, null));
                });
                ctrl.navTitle = ctrl.title || 'seochecker.categories';
            } else if (angular.isArray(ctrl.navigationIndex)) {
                angular.forEach(ctrl.navigationIndex, function (item) {
                    if (item && item.id) {
                        items.push(createItem(item.id, item.title, item.order, item.score));
                    }
                });
                ctrl.navTitle = ctrl.title || 'seochecker.exams';
            }

            ctrl.items = $filter('orderBy')(items, 'order');

            var previousStillExists = false;
            for (var i = 0; i < ctrl.items.length; i++) {
                if (ctrl.items[i].id === previousActiveId) {
                    previousStillExists = true;
                    break;
                }
            }

            ctrl.activeId = previousStillExists
                ? previousActiveId
                : (ctrl.items.length ? ctrl.items[0].id : null);
        }

        function createItem(id, title, order, score) {
            var numericScore = score === null || score === undefined || score === '' ? null : Number(score);

            if (numericScore !== null && isNaN(numericScore)) {
                numericScore = null;
            }

            return {
                id: String(id),
                title: decodeHtmlEntities(title),
                order: order || 0,
                score: numericScore,
                statusClass: getStatusClass(numericScore)
            };
        }

        function decodeHtmlEntities(value) {
            if (value === null || value === undefined) {
                return '';
            }
            var textarea = doc.createElement('textarea');
            textarea.innerHTML = String(value);
            return textarea.value;
        }

        function getStatusClass(score) {
            if (score === null) {
                return '';
            }
            if (score >= 75) {
                return 'st-exam-nav__dot--good';
            }
            if (score >= 50) {
                return 'st-exam-nav__dot--warn';
            }
            return 'st-exam-nav__dot--bad';
        }

        function findScrollContainer() {
            var node = $element[0].parentNode;
            var fallback = null;

            while (node && node.nodeType === 1) {
                if (node.hasAttribute('du-scroll-container') || node.id === 'seochecker-container') {
                    return node;
                }

                if (!fallback) {
                    var overflowY = $window.getComputedStyle(node).overflowY;
                    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
                        fallback = node;
                    }
                }

                node = node.parentNode;
            }

            return fallback || $window;
        }

        function bindScrollListeners() {
            if (listenersBound) {
                return;
            }

            scrollContainer = findScrollContainer();

            if (scrollContainer === $window) {
                $window.addEventListener('scroll', onScroll, false);
            } else {
                scrollContainer.addEventListener('scroll', onScroll, false);
            }

            $window.addEventListener('resize', onScroll, false);
            listenersBound = true;
        }

        function unbindScrollListeners() {
            if (!listenersBound) {
                return;
            }

            if (scrollContainer === $window) {
                $window.removeEventListener('scroll', onScroll, false);
            } else if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', onScroll, false);
            }

            $window.removeEventListener('resize', onScroll, false);
            listenersBound = false;
        }

        function onScroll() {
            if (activeLockId) {
                return;
            }

            if (rafId) {
                return;
            }

            rafId = requestFrame(function () {
                rafId = null;
                updateActiveSection();
            });
        }

        function updateActiveSection() {
            if (!ctrl.items.length || (scrollContainer && scrollContainer.clientHeight === 0)) {
                return;
            }

            var activeItem = ctrl.items[0];
            var container = scrollContainer || findScrollContainer();
            var isWindowScroll = container === $window;
            var scrollTop = isWindowScroll
                ? ($window.pageYOffset || doc.documentElement.scrollTop || doc.body.scrollTop || 0)
                : container.scrollTop;
            var viewportHeight = isWindowScroll ? $window.innerHeight : container.clientHeight;
            var readingLine = scrollTop + Math.min(96, Math.max(40, viewportHeight * 0.18));
            var containerRect = isWindowScroll ? null : container.getBoundingClientRect();
            var docHeight = isWindowScroll
                ? Math.max(doc.documentElement.scrollHeight, doc.body.scrollHeight)
                : container.scrollHeight;
            var atBottom = scrollTop + viewportHeight >= docHeight - 3;

            for (var i = 0; i < ctrl.items.length; i++) {
                var target = doc.getElementById(ctrl.items[i].id);
                if (!target) {
                    continue;
                }

                var targetTop = isWindowScroll
                    ? target.getBoundingClientRect().top + scrollTop
                    : target.getBoundingClientRect().top - containerRect.top + scrollTop;

                if (targetTop <= readingLine + 1) {
                    activeItem = ctrl.items[i];
                } else {
                    break;
                }
            }

            // The final section can be shorter than the reading line. Once the
            // container is at the end, it is the section the user is viewing.
            if (atBottom) {
                activeItem = ctrl.items[ctrl.items.length - 1];
            }

            setActive(activeItem.id, false);
        }

        function setActive(id, force) {
            if (!force && ctrl.activeId === id) {
                return;
            }

            ctrl.activeId = id;
            $scope.$applyAsync();
            ensureActiveVisible(id);
        }

        function ensureActiveVisible(id) {
            var list = $element[0].querySelector('.st-exam-nav__list');
            var item = findItemElement(id);

            if (!list || !item) {
                return;
            }

            var itemTop = item.offsetTop;
            var itemBottom = itemTop + item.offsetHeight;

            if (itemTop < list.scrollTop) {
                list.scrollTop = Math.max(0, itemTop - 4);
            } else if (itemBottom > list.scrollTop + list.clientHeight) {
                list.scrollTop = itemBottom - list.clientHeight + 4;
            }
        }

        function findItemElement(id) {
            var buttons = $element[0].querySelectorAll('.st-exam-nav__item');

            for (var i = 0; i < buttons.length; i++) {
                if (buttons[i].getAttribute('data-target') === id) {
                    return buttons[i];
                }
            }

            return null;
        }

        function focusItem(id) {
            $timeout(function () {
                var item = findItemElement(id);
                if (item) {
                    item.focus();
                }
            }, 0, false);
        }

        function getScrollTopFor(target, container) {
            if (container === $window) {
                return target.getBoundingClientRect().top
                    + ($window.pageYOffset || doc.documentElement.scrollTop || 0) - 16;
            }

            return target.getBoundingClientRect().top
                - container.getBoundingClientRect().top
                + container.scrollTop - 16;
        }

        function smoothScrollTo(container, top) {
            if (container === $window) {
                if ('scrollBehavior' in doc.documentElement.style) {
                    $window.scrollTo({top: top, behavior: 'smooth'});
                    return;
                }

                animateScroll(
                    function () { return $window.pageYOffset || doc.documentElement.scrollTop || 0; },
                    function (value) { $window.scrollTo(0, value); },
                    top
                );
                return;
            }

            if ('scrollBehavior' in container.style) {
                container.scrollTo({top: top, behavior: 'smooth'});
                return;
            }

            animateScroll(
                function () { return container.scrollTop; },
                function (value) { container.scrollTop = value; },
                top
            );
        }

        function animateScroll(getCurrent, setCurrent, targetTop) {
            var startTop = getCurrent();
            var distance = targetTop - startTop;
            var duration = 320;
            var startTime = null;

            if (!distance) {
                return;
            }

            function step(timestamp) {
                if (startTime === null) {
                    startTime = timestamp;
                }

                var progress = Math.min((timestamp - startTime) / duration, 1);
                var eased = 1 - Math.pow(1 - progress, 3);
                setCurrent(startTop + distance * eased);

                if (progress < 1) {
                    requestFrame(step);
                }
            }

            requestFrame(step);
        }

        function lockActiveSection(id) {
            activeLockId = id;

            if (activeLockTimer) {
                $timeout.cancel(activeLockTimer);
            }

            activeLockTimer = $timeout(function () {
                activeLockId = null;
                activeLockTimer = null;
                updateActiveSection();
            }, 1000, false);
        }

        function requestFrame(callback) {
            if ($window.requestAnimationFrame) {
                return $window.requestAnimationFrame(callback);
            }

            return $window.setTimeout(callback, 16);
        }

        function cancelFrame(id) {
            if ($window.cancelAnimationFrame) {
                $window.cancelAnimationFrame(id);
            } else {
                $window.clearTimeout(id);
            }
        }
    }

    return {
        templateUrl: 'app/modules/seochecker/components/exams-navigator/exams-navigator.html',
        bindings: {
            navigationIndex: '<',
            exams: '<',
            categories: '<',
            title: '<'
        },
        controller: ['$scope', '$element', '$timeout', '$window', '$filter', ExamsNavigatorController]
    };
});
